import Container from "react-bootstrap/Container";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Image } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import { Form } from "react-bootstrap";
import logo from "../../PatientList/logo.png";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { LoginService, PatientService } from "../../../services";
import ImageCarousel from "./ImageCarousel";
import "./ActionDetail.css"

function ActionKargoDetail() {
  const [images, setImages] = useState({});
  const [imageIds, setImageIds] = useState([])
  const [showImageCarousel, setShowImageCarousel] = useState(false);
  const [imageCarouselIndex, setImageCarouselIndex] = useState(0);
  const params = useParams();
  const { state } = useLocation();
  const user = LoginService.getUser();

  const downloadFile = (fileUrl, filename) => {
    console.log("file save started");
    PatientService.downloadFile(fileUrl).then((response) => {
      console.log("download completed");
      // create file link in browser's memory
      const href = URL.createObjectURL(response);

      // create "a" HTML element with href to file & click
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    });

    console.log("file save ended");
  };

  useEffect(() => {
    const cargoId = params.Id.split("-")[0];

    PatientService.getImageSet(cargoId).then((json) => {
      const imgs = {};
      const imageIds = [];
      Object.keys(json[0]).map((i) => {
        if (i.includes("Img") == true) {
          if (json[0][i]) {
            const img = `https://service.orthomagic.com.tr:8447/OrthoMagic/GetImage?ImageId=TN-${json[0][i]}&GUID=${user.SessionGUID}&UserId=${user.UserId}`;
            const img_download = `https://service.orthomagic.com.tr:8447/OrthoMagic/GetImage?ImageId=${json[0][i]}&GUID=${user.SessionGUID}&UserId=${user.UserId}`;
            imgs[i] = img;
            imgs[i + "_download"] = img_download;
            imageIds.push(json[0][i])
          }
        }
      });

      setImages(imgs);
      setImageIds(imageIds)
    });

    return () => {};
  }, []);


  const showCarousel = (index) => {
    setImageCarouselIndex(index)
    setShowImageCarousel(true)
  }

  const renderImage = (imageName, index, className="col-12 col-md-3 p-2 position-relative") => {
    return <Col className={className}>
      {images[imageName] && <Button
        variant="secondary"
        className="open-image-button"
        onClick={()=>{showCarousel(index)}}
      >
        <i className="fa fa-search-plus"></i>
      </Button>
      }
      <Image height={"300px"} width={"100%"} src={images[imageName]} />
    </Col>
  }

  return (
    <Container className="col-12 col-md-9 mt-5">
      {showImageCarousel && <ImageCarousel index={imageCarouselIndex} images={imageIds} onClose={()=>setShowImageCarousel(false)}/>}
      <div>
        <Row>
          <h3>Stl File Upper Arch:</h3>
          <Col className="col-12 col-md-9">
            {" "}
            <Link
              onClick={() =>
                downloadFile(images["Img11_download"], "upper_arch.stl")
              }
            >
              {" "}
              Download Upper Arch
            </Link>{" "}
          </Col>
        </Row>
        <Row>
          <h3>Stl File Lower Arch:</h3>
          <Col className="col-12 col-md-9">
            {" "}
            <Link
              onClick={() =>
                downloadFile(images["Img12_download"], "lower_arch.stl")
              }
            >
              {" "}
              Download Lower Arch{" "}
            </Link>{" "}
          </Col>
        </Row>
      </div>

      <Row className="mt-5">
        <h3>Intraoral Images:</h3>
      </Row>
      <Row>
        {renderImage('Img1', 0)}
        {renderImage('Img2', 1)}
        {renderImage('Img3', 2)}
      </Row>
      <Row>
        {renderImage('Img4', 3)}
        <Col className="flex-md-wrap align-items-center d-none d-md-flex text-middle col-12 col-md-3 p-2">
          {" "}
          <Image
            width={"100%"}
            alt=""
            className="Dropzone-img d-inline m-auto"
            src={logo}
            fluid
          />
        </Col>
        {renderImage('Img5', 4)}
      </Row>
      <Row>
        {renderImage('Img6', 5)}
        {renderImage('Img7', 6)}
        {renderImage('Img8', 7)}
      </Row>
      <Row className="mt-5">
        <h3>Panoramic Image:</h3>
      </Row>
      <Row>
        {renderImage('Img9', 8, 'col-12 col-md-9')}
      </Row>
      <Row className="mt-5">
        <h3>Sefalometric Image:</h3>
      </Row>
      <Row>
        {renderImage('Img10', 10, 'col-12 col-md-9')}
      </Row>
    </Container>
  );
}

export default ActionKargoDetail;
